module.exports = require("events");


//////////////////
// WEBPACK FOOTER
// external "events"
// module id = 25
// module chunks = 0